module.exports = __webpack_public_path__ + "img/security-unknown-source.9c630a49.webp";